import { useState } from 'react';

import { motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';

export function FileNumberDisclaimer() {
  const [disclaimerExpanded, setDisclaimerExpanded] = useState(false);

  return (
    <motion.div
      className="absolute top-0 right-0 left-0 m-3 cursor-pointer overflow-hidden rounded-lg border border-blue-300 bg-blue-50 text-xs text-blue-500 shadow-lg/4 shadow-blue-500 transition-colors duration-150 hover:border-blue-400"
      onClick={() => setDisclaimerExpanded(!disclaimerExpanded)}
      initial={false}
      animate={{
        height: disclaimerExpanded ? 'auto' : '2.0625rem',
      }}
      transition={{
        duration: 0.15,
        ease: 'easeInOut',
      }}
    >
      <p className="flex items-center gap-1.5 p-2 px-3 font-medium">
        <Icon className="lucide--info" />
        <span className="line-clamp-1">Uploading a large number of files?</span>
        <motion.span
          className="ml-auto text-blue-400"
          animate={{ rotate: disclaimerExpanded ? 180 : 0 }}
          transition={{ duration: 0.15, ease: 'easeInOut' }}
        >
          <Icon className="lucide--chevron-down" />
        </motion.span>
      </p>
      <p className="p-2 px-3 pt-0">
        Submitting too many individual files directly may cause your browser to struggle. Consider uploading ZIP
        archives instead if you have more than 2000 files.
      </p>
    </motion.div>
  );
}
